export default "/_next/static/assets/iah-phone-mask_65b56beb72288c852ae5fc63d487dfe2.png";